module.exports = __webpack_public_path__ + "fonts/Inter-200-greek-ext31.af80f40.woff2";